/**
 *
 *@author zcc
 *@date 2022/3/10 14:26
 */
import { UrlConfig } from '@/config/UrlConfig';

export class LoginUrlConfig {
  public static loginUrl = `${UrlConfig.websiteBaseurl}/thirdparty/login`;

  public static forgetPassword = `${UrlConfig.websiteBaseurl}/thirdparty/developer/password`;
}
